import React, { useState } from 'react';
import { Section } from './Section';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
interface AccordionItemProps {
  question: string;
  answer: string;
  isOpen: boolean;
  onClick: () => void;
}
function AccordionItem({
  question,
  answer,
  isOpen,
  onClick
}: AccordionItemProps) {
  return <div className="border border-slate-200 rounded-2xl mb-4 overflow-hidden bg-white" data-id="element-317">
      <button className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" onClick={onClick} data-id="element-318">
        <span className="font-heading font-bold text-navy-900 pr-8" data-id="element-319">
          {question}
        </span>
        <ChevronDown className={`w-5 h-5 text-accent transition-transform duration-300 shrink-0 ${isOpen ? 'rotate-180' : ''}`} data-id="element-320" />
      </button>
      <AnimatePresence data-id="element-321">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} data-id="element-322">
            <div className="px-6 pb-5 text-slate-600 leading-relaxed border-t border-slate-100 pt-4" data-id="element-323">
              {answer}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
export function Objections() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    q: '¿Esto sirve si será mi primera tienda online?',
    a: 'Sí. BitzenEscala™ está diseñado especialmente para pymes retail que están dando el paso al canal online por primera vez y quieren hacerlo con estructura desde el inicio, sin improvisar.'
  }, {
    q: '¿Qué pasa si ya tengo una tienda pero no funciona?',
    a: 'Revisamos tu caso. En muchos escenarios, BitzenEscala™ se aplica como reconstrucción o migración estratégica de un ecommerce que se hizo sin criterio comercial.'
  }, {
    q: '¿La tienda garantiza ventas?',
    a: 'No. Las ventas dependen de producto, oferta, tráfico, operación comercial y seguimiento. Lo que sí entregamos es la estructura profesional para que el canal online pueda convertir cuando llega el tráfico correcto.'
  }, {
    q: '¿Necesito tener todo el catálogo ordenado?',
    a: 'No es requisito inicial. Parte del proceso es ayudarte a estructurar catálogo, fichas y categorías de forma que tengan lógica comercial.'
  }, {
    q: '¿Voy a poder administrar la tienda?',
    a: 'Sí. El sistema queda preparado para que tu equipo administre productos, pedidos, stock y promociones sin depender de un desarrollador.'
  }, {
    q: '¿Qué pasa si todavía no tengo fotos profesionales?',
    a: 'Lo abordamos en la evaluación. Podemos avanzar con material actual y planificar mejoras visuales en etapas posteriores.'
  }, {
    q: '¿Cuánto puede costar una implementación?',
    a: 'Las implementaciones de BitzenEscala™ se mueven entre 20 UF y 89 UF dependiendo del alcance: cantidad de productos, integraciones, automatización y nivel de acompañamiento. En la evaluación inicial definimos el rango realista para tu caso.'
  }, {
    q: '¿Qué ocurre después de la evaluación inicial?',
    a: 'Si tu pyme aplica, se agenda una sesión estratégica para definir el alcance del proyecto, los plazos y la propuesta formal de implementación.'
  }];
  return <Section className="bg-slate-50" data-id="element-324">
      <div className="max-w-3xl mx-auto" data-id="element-325">
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-navy-900 mb-10 text-center" data-id="element-326">
          Preguntas que probablemente te haces antes de invertir en tu canal
          online
        </h2>

        <div className="space-y-4" data-id="element-327">
          {faqs.map((faq, index) => <AccordionItem key={index} question={faq.q} answer={faq.a} isOpen={openIndex === index} onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-328" />)}
        </div>
      </div>
    </Section>;
}